import { createActionName } from "../../../utility"

export const reducerName = "tags"

export const TAG = createActionName(reducerName, "TAG")
export const TAGS = createActionName(reducerName, "TAGS")
